<div empty class="px-4 py-6 flex justify-center items-center bg-white">
    <ng-content></ng-content>
</div>
